module.exports = __webpack_public_path__ + "img/apple-store.1c73f0ba.png";